import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin":"0 auto","padding":"30px"} }
const _hoisted_2 = { style: {"background":"#fafafa","padding":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff3535"} }, "并置于往期人员", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff3535"} }, "【同属于当期人员】", -1)
const _hoisted_5 = { style: {"background":"#fafafa","padding":"10px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff3535"} }, "并置于往期人员", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff3535"} }, "【同属于当期人员】", -1)

import {
  withDefaults,
  reactive,
  ref,
  computed
} from 'vue';
import {
  BaseButton,
  BaseDatePicker,
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseRadio,
  BaseRadioGroup,
  BaseUpload,
  XrkMessage,
  XrkLoading,
  XrkMessageBox,
  createDialog,
  BaseCheckbox
} from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import {
  downloadTemplate,
  downloadSurplus,
  cleanProjectWorkload,
  checkImportExcel,
  importProjectPeople,
  againSubmit
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';

import ProjectPersonFailTable from './project-person-fail-table.vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-person-purchase',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    isSceneType19: { type: Boolean }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});
// 表单实例
const formRef = ref<BaseFormRef>(null);
// upload上传
const upload = ref(null);
const fileList = ref([]);
// 声明 prop 属性
const props = __props;
const emits = __emit;
const disabledDate = time => {
  const cur = new Date();
  const curDate = cur.getDate() - 1;
  cur.setDate(curDate);
  return time.getTime() < cur.getTime();
};
const form = reactive<{
  projectId: number; //项目id
  projectCode: string;
  prePurchaseAt: string; //预采购时间  格式  2022-03-31
  coverMethod: number;
  summationMethod: number;
  importMethod: number;
  file?: any; //文件（没有就不用传）
}>({
  projectId: projectInfo.value.id,
  projectCode: projectInfo.value.projectCode,
  prePurchaseAt: '',
  coverMethod: null,
  summationMethod: null,
  importMethod: null,
  file: null
});
const excelCode = ref('');

//生成唯一id
function generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onCancel = () => {
  props.remove();
};

const againSubmitPerson = async (inVO, dataList) => {
  const { data } = await againSubmit({ inVO, dataList });
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: true,
      showFooter: false,
      contentRender: done => {
        return (
          <ProjectPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></ProjectPersonFailTable>
        );
      }
    });
    props.remove();
  }
};

const projectShowFlag = ref(1);

const onConfirm = async () => {
  await formRef.value.validate();
  if (!fileList.value.length) {
    XrkMessage.error('请上传文件！');
  } else {
    excelCode.value = generateUniqueId();
    const { data } = await checkImportExcel({
      file: fileList.value[0].raw,
      projectCode: projectInfo.value.projectCode
    });

    const submit = async () => {
      const inVO = {
        projectShowFlag: projectShowFlag.value,
        excelName: fileList.value[0].name,
        projectId: form.projectId,
        projectCode: form.projectCode,
        prePurchaseAt: form.prePurchaseAt,
        coverMethod: form.coverMethod,
        summationMethod: form.summationMethod,
        importMethod: form.importMethod,
        excelUploadUrl: fileList.value[0].url,
        excelCode: excelCode.value
      };
      const params = {
        inVO: JSON.stringify(inVO),
        file: fileList.value[0].raw
      };
      const { data } = await importProjectPeople(params);
      if (data.failCount === 0) {
        XrkMessage.success('导入成功');
        emits('success');
        props.remove();
      } else {
        createDialog({
          width: '1300px',
          title: '导入失败',
          showClose: true,
          showFooter: false,
          contentRender: done => {
            return (
              <ProjectPersonFailTable
                form={{
                  excelCode: excelCode.value
                }}
                onAgainSubmit={async ({ dataList }) => {
                  await againSubmitPerson(inVO, dataList);
                }}
                importCount={data.importCount}
                failCount={data.failCount}
                dataList={data.dataList}
                done={done}
              ></ProjectPersonFailTable>
            );
          }
        });
        props.remove();
      }
    };
    if (data[1] > 0) {
      const tips = `您上传的人员名单为${data[0]}人，其中${data[1]}人未设置人员标签，是否继续？`;
      createDialog({
        width: '500px',
        title: '是否继续',
        showClose: false,
        showFooter: true,
        contentRender: () => {
          return (
            <>
              <div style="padding: 20px">
                <p>{tips}</p>
                <BaseCheckbox
                  v-model={projectShowFlag.value}
                  trueValue={2}
                  falseValue={1}
                >
                  本项目不再提示
                </BaseCheckbox>
              </div>
            </>
          );
        },
        async beforeConfirm() {
          await submit();
        },
        async beforeCancel(done) {
          await done();
        }
      });
    } else {
      await submit();
    }
  }
};

/**
 * 清零上期预采购任务量
 * @param {number} projectId 项目ID
 */
async function removeLatestTask() {
  await XrkMessageBox.confirm(
    '此操作将清零上期预采购任务量, 是否继续?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  );

  // 显示loading
  const loading = XrkLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  try {
    // 发送清零任务请求
    await cleanProjectWorkload({
      projectId: projectInfo.value.id
    });

    // 显示成功提示
    XrkMessage.success('上期预采购任务量已清零');
    emits('success');
    // 关闭loading
    loading.close();
  } catch (e) {
    // 关闭loading
    loading.close();
  }
}

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const procurementPersonnel = () => {
  const excelGroupCode = isGeti.value
    ? 'import_individual_pre_purchase'
    : 'import_pre_purchase';
  downloadTemplate({
    excelGroupCode
  });
};

const downLodTaskPlanExcel = async () => {
  await downloadSurplus({
    projectId: projectInfo.value.id
  });
};
const lastMonthDate = new Date();
lastMonthDate.setMonth(lastMonthDate.getMonth() + 1);
lastMonthDate.setDate(0);
form.prePurchaseAt = formatter.date(lastMonthDate.getTime()) as string;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "预采购任务量",
    width: "700px"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          "label-width": "auto",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              rules: [{ required: true, message: '请选择日期' }],
              label: "预采购时间：",
              prop: "prePurchaseAt"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatePicker), {
                  disabledDate: disabledDate,
                  modelValue: form.prePurchaseAt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.prePurchaseAt) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "预采购任务量：",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _createVNode(_unref(BaseButton), {
                      icon: _unref(Download),
                      type: "text",
                      onClick: downLodTaskPlanExcel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 下载剩余量 ")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_unref(BaseButton), {
                      icon: _unref(Download),
                      type: "text",
                      onClick: procurementPersonnel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 下载数据模板 ")
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _createVNode(_unref(BaseUpload), {
                    ref_key: "upload",
                    ref: upload,
                    fileList: fileList.value,
                    "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                    style: {"width":"360px"},
                    "http-request": httpRequest,
                    "auto-upload": true,
                    multiple: false,
                    accept: ['.xls', '.xlsx'],
                    onError: onError,
                    limit: 1,
                    "limit-size": 20,
                    drag: true,
                    btnText: "上传人员名单"
                  }, {
                    tip: _withCtx(() => [
                      _createTextVNode(" 上传格式为 xls 或 xlsx 文件，最大支持20M。 ")
                    ]),
                    _: 1
                  }, 8, ["fileList"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              rules: [{ required: true, message: '请选择导入方式' }],
              label: "导入方式：",
              prop: "importMethod"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(BaseRadioGroup), {
                    modelValue: form.importMethod,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.importMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseRadio), { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("覆盖原数据")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BaseRadio), { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("累加原数据")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (form.importMethod === 1)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  label: "",
                  prop: "coverMethod",
                  rules: [{ required: true, message: '请选择覆盖方式' }]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(BaseRadioGroup), {
                        modelValue: form.coverMethod,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.coverMethod) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseRadio), { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 按当前表单执行，非表单内的人员任务量清空， "),
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(BaseRadio), { value: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 修改当前表单内的人员任务量，非表单内人员任务量不变 "),
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.importMethod === 2)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 1,
                  label: "",
                  prop: "summationMethod",
                  rules: [{ required: true, message: '请选择累加方式' }]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(BaseRadioGroup), {
                        modelValue: form.summationMethod,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.summationMethod) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BaseRadio), { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 累加当前表单内人员的任务量与剩余量，非表单内的执行人任务量清零， "),
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(BaseRadio), { value: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 只累加当前表单内人员的任务量，非表单内的执行人任务量不变 "),
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"]),
        (!_ctx.isSceneType19)
          ? (_openBlock(), _createBlock(_unref(BaseButton), {
              key: 0,
              type: "danger",
              plain: "",
              onClick: removeLatestTask
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 上期预采购任务量清零 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})